module.exports = {"532524101":"临安镇","532524102":"官厅镇","532524103":"西庄镇","532524104":"青龙镇","532524105":"南庄镇","532524106":"岔科镇","532524107":"曲江镇","532524108":"面甸镇","532524201":"普雄乡","532524202":"李浩寨乡","532524203":"坡头乡","532524204":"盘江乡","532524205":"利民乡","532524206":"甸尾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532524.json
// module id = 2629
// module chunks = 0